import { render, staticRenderFns } from "./pengajuanDetail.vue?vue&type=template&id=c3a4c84e&scoped=true"
import script from "./pengajuanDetail.vue?vue&type=script&lang=js"
export * from "./pengajuanDetail.vue?vue&type=script&lang=js"
import style0 from "./pengajuanDetail.vue?vue&type=style&index=0&id=c3a4c84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a4c84e",
  null
  
)

export default component.exports